import { Box } from '@mui/material';
import React, { useRef } from 'react';
import BaseVideo from 'components/video/BaseVideo';
import { useMediaQuery } from '@mui/system';
import appTheme from 'ui-blocks/AppTheme';
import { characteristicsSectionStyles } from '../characteristicsSectionStyles';

const baseUrl = `${process.env.REACT_APP_S3_BASE_URL}/29_april_revamp/product`;

export default function CharacterCharacteristicVideos() {
	const isTablet = useMediaQuery(appTheme.breakpoints.down('mobileUi'));
	const isMobile = useMediaQuery(appTheme.breakpoints.down('smTab'));

	const videoRefs = useRef([useRef(null), useRef(null), useRef(null), useRef(null)]);
	const autoPlayIndex = 1;

	const handleMouseEnter = (index) => {
		videoRefs.current.forEach((videoRef) => {
			videoRef?.current?.handleVideoPause();
		});
		videoRefs.current[index]?.current?.handleVideoPlay();
	};

	const handleMouseLeave = (index) => {
		videoRefs.current[index]?.current?.handleVideoPause();
		videoRefs.current[autoPlayIndex]?.current?.handleVideoPlay();
	};

	return (
		<Box
			id="character-chracteristic-video-container"
			sx={[characteristicsSectionStyles.videoContainer]}
		>
			{/* Top Videos */}
			<Box
				id="character-chracteristic-top-videos"
				sx={[characteristicsSectionStyles.topVideoContainer]}
			>
				{[
					{
						id: 'product_video_1',
						src: `${baseUrl}/product_video_1.mp4`,
						poster: `${baseUrl}/thumbnail_product_video_1.webp`,
					},
					{
						id: 'product_video_2',
						src: `${baseUrl}/product_video_2.mp4`,
						poster: `${baseUrl}/thumbnail_product_video_2.webp`,
					},
				].map((video, index) => (
					<Box
						key={`top-video-${video.id}`}
						sx={{ flex: index === 0 ? '0.47' : '1' }}
						id={`character-characteristic-${index + 1}`}
						onMouseEnter={() => handleMouseEnter(index)}
						onMouseLeave={() => handleMouseLeave(index)}
					>
						<BaseVideo
							ref={videoRefs.current[index]}
							src={video.src}
							poster={video.poster}
							controls={false}
							autoPlay={isTablet || index === autoPlayIndex}
							muted
							loop
							playPauseIcon={false}
							showSkeletonLoading
							playsInline
							style={{
								...characteristicsSectionStyles.baseVideo,
								borderRadius: isMobile ? '16px' : '32px',
							}}
							containerStyle={{
								width: '100%',
								aspectRatio: index === 0 ? '0.55' : '1.17',
							}}
						/>
					</Box>
				))}
			</Box>

			{/* Bottom Videos */}
			<Box
				id="character-chracteristic-bottom-videos"
				sx={[characteristicsSectionStyles.bottomVideoContainer]}
			>
				{[
					{
						id: 'product_video_3',
						src: `${baseUrl}/product_video_3.mp4`,
						poster: `${baseUrl}/thumbnail_product_video_3.webp`,
					},
					{
						id: 'product_video_4',
						src: `${baseUrl}/product_video_4.mp4`,
						poster: `${baseUrl}/thumbnail_product_video_4.webp`,
					},
				].map((video, index) => (
					<Box
						key={`bottom-video-${video.id}`}
						id={`character-characteristic-${index + 3}`}
						sx={{ flex: index === 0 ? '0.73' : '1' }}
						onMouseEnter={() => handleMouseEnter(index + 2)}
						onMouseLeave={() => handleMouseLeave(index + 2)}
					>
						<BaseVideo
							ref={videoRefs.current[index + 2]}
							src={video.src}
							poster={video.poster}
							controls={false}
							autoPlay={isTablet}
							muted
							loop
							playPauseIcon={false}
							showSkeletonLoading
							playsInline
							style={{
								...characteristicsSectionStyles.baseVideo,
								borderRadius: isMobile ? '16px' : '32px',
							}}
							containerStyle={{
								width: '100%',
								aspectRatio: index === 0 ? '1' : '1.36',
							}}
						/>
					</Box>
				))}
			</Box>
		</Box>
	);
}
